export const districts = [
  {value: '1', label: 'District 1'},
  {value: '2', label: 'District 2'},
  {value: '3', label: 'District 3'},
]
